import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Swiper, { Controller, Navigation, Pagination, EffectFade } from 'swiper';
import Panzoom from '@panzoom/panzoom'

Swiper.use([Controller, Navigation, Pagination, EffectFade]);

class Lightbox {
    constructor(trigger) {
        this.trigger = trigger;
        this.isOpen = false;
        this.hasOpened = false;

        this.getElements();
        this.addEvents();
    }

    getElements() {
        this.rootElem = document.querySelector('html');
        this.container = document.querySelector('.js-lightbox-container');
        this.closeTrigger = this.container.querySelector('.product-lightbox__close');
    }

    addEvents() {
        this.trigger.addEventListener('click', () => {
            this.toggle();
        })

        this.closeTrigger.addEventListener('click', () => {
            this.close();
        })
    }

    toggle() {
        if (!this.isOpen) {
            this.open();
            if (!this.hasOpened) {
                setTimeout(() => {
                    this.enableCarousels();
                }, 100);

                this.hasOpened = true;
            }
        } else {
            this.close();
        }
    }

    open() {
        this.container.classList.add('is-active');
        disableBodyScroll(this.rootElem);

    }

    close() {
        this.container.classList.remove('is-active');
        enableBodyScroll(this.rootElem);
    }

    enableCarousels() {
        this.carousel = new Swiper(this.container.querySelector('.carousel'), {
            speed: 400,
            spaceBetween: 0,
            loop: false,
            slidesPerView: 1,
            autoplay: false,
            centeredSlides: true,
            fadeEffect: {
                crossFade: true
            },
            effect: 'fade',
            observer: true,
            observeParents: true,
            initialSlide: 0,
        });

        this.carousel.on('slideChange', () => {
            this.carousel.slides[this.carousel.activeIndex].classList.remove('is-zoomed', 'zoom-out');
            this.enableZoom(this.carousel.slides[this.carousel.activeIndex]);
        });

        this.enableZoom(this.carousel.slides[this.carousel.activeIndex]);
        this.handleCarouselNav();
    }

    enableZoom(slide) {
        let clickCount = 0;
        const zoomElement = slide.querySelector('.product-lightbox-slide__zoom');
        const zoomTrigger = slide.querySelector('.product-lightbox-slide__zoom-trigger');

        const panzoom = Panzoom(zoomElement, {
            contain: 'outside',
            panOnlyWhenZoomed: true,
            startScale: 1,
            maxScale: 2
        });

        panzoom.pan(0, 0);

        zoomTrigger.addEventListener('click', () => {
            clickCount++;

            if (clickCount === 1) {
                panzoom.zoom(1.5, {
                    animate: true
                });
                slide.classList.add('is-zoomed');
            } else if (clickCount === 2) {
                panzoom.zoom(2, {
                    animate: true
                });
                slide.classList.add('zoom-out');
            } else {
                panzoom.reset({ animate: true });
                slide.classList.remove('is-zoomed', 'zoom-out');
                clickCount = 0;
            }
        });

    }

    handleCarouselNav() {
        const navItems = this.container.querySelectorAll('.product-lightbox-nav__item');

        navItems.forEach((item) => {
            item.addEventListener('click', () => {
                const id = parseInt(item.dataset.target, 10);
                this.carousel.slideTo(id);
            });
        })
    }
}

export function initLightbox() {
    const triggers = document.querySelectorAll('.js-lightbox-trigger');

    if (triggers.length > 0) {
        triggers.forEach(trigger => {
            const lightbox = new Lightbox(trigger);
        })
    }
}